import React from 'react';
import { Button, Alert, Card, Row, Col, Container } from 'react-bootstrap';
import { RenderHeader } from '../_components/Header';
import { NavbarSmart } from '../_components/NavbarSmart';
import Cookies from 'universal-cookie';
import axios from 'axios';
import {FaCheck, FaQuestion} from 'react-icons/fa';

function Companies() {

    // state vars
    const [companiesList, setCompaniesList] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [companyStatus, setCompanyStatus] = React.useState(null);

    async function fetchCompanies() {
      setIsLoading(true);
      const cookies = new Cookies();
      const submitItems = {
          email: cookies.get("e"),
          authToken: cookies.get("t")
      }
      await axios.post(process.env.REACT_APP_BASE_URL + 'jobs/companies/companies100', submitItems)
        .then( response => {
            // console.log(response.data)
            setCompaniesList(response.data)
            setIsLoading(false);
        }).catch(error => {
          console.error(error);
        });

    }

    async function fetchCompanyStatus() {
      const cookies = new Cookies();
      const submitItems = {
          email: cookies.get("e"),
          authToken: cookies.get("t")
      }
      await axios.post(process.env.REACT_APP_BASE_URL + 'jobs/companies/companyStatus', submitItems)
        .then( response => {
            // console.log(response.data)
            setCompanyStatus(response.data)
        }).catch(error => {
          console.error(error);
        });
    }

    function newWindow(newPageUrl) {
      // console.log('newWindow')
      window.open(newPageUrl, "_blank");
    }



    React.useEffect(() => {
      fetchCompanies();
      fetchCompanyStatus();
    }, []);


    return (
      <>
        <RenderHeader />
        <NavbarSmart showLoggedIn='true' />
        { isLoading ? <Alert>Loading...</Alert> : <></> }

        <Container>
          <Row>
            <Col >
              
              <div style={{ display: "flex", flexWrap: "wrap", alignContent: "center", justifyContent: "space-around" }}>
              
                {companiesList && companiesList.map((company, companyId) => (
                  <Card as="span" key={companyId} style={{margin: "20px"}} > 
                  {/* // style={{width: "30%"}}> */}
                    <Card.Body>
                      <Card.Title tag="h5">
                        {company.companyName}
                        {companyStatus && companyStatus.find(item => item.companyId === company.companyId).status === "success"  ? <>&nbsp;&nbsp;

                        <FaCheck style={{width:"15px", color:"green"}}/>
                      </> : <>
                        &nbsp;&nbsp;<FaQuestion style={{width:"15px", color:"orange"}}/>
                       </>}


                      </Card.Title>
                      <Card.Subtitle
                        className="mb-2 text-muted"
                        tag="h6"
                      >
                        {company.jobCount} Jobs Posted
                      </Card.Subtitle>
                      <Card.Text className="text-center">
                        &nbsp;<br/>
                      
                      <Button onClick={() => newWindow(company.companyUrl)}>
                        See Their Jobs
                      </Button>

                      </Card.Text>
                        
                    </Card.Body>
                    
                  </Card>

                ))}
              
              </div>

              

              
            </Col>
          </Row>
        </Container>
      </>
    )

}

export default Companies;